import ServiceHero from '@/components/sections/ServiceHero'

export default function DesignHero() {
  return (
    <ServiceHero
      serviceName="Design"
      titleLines={['Brand &', 'Identity']}
      description="In a crowded market, fitting in is a death sentence. We forge distinct identity systems that scale across every touchpoint — making your brand impossible to ignore."
    />
  )
}
